import $ from 'jquery';
import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { createProductSlider } from '../../dom/products';
import ProductSliderItem from '../ProductSlider/ProductSliderItem';

function RelatedProductList(props) {
    const {
        list,
        sliderSectionID,
        currencyFormat,
        currencyDisplayCode,
        locale,
    } = props;
    let $sliderContainer = $(sliderSectionID);

    /**
     * HACKED VERSION TO MAKE THIS RUN
     * To whoever maintaining this, good luck :)
     *
     * Your dearest, Stephy
     */
    const duplicateSlideItem = () => {
        let $sliderItems = $sliderContainer
                .find('.tmp-product-slider')
                .children()
                .clone(),
            $sliderItemsContainer = $sliderContainer.find(
                '.products-slider .slider__cycle'
            );

        $sliderItemsContainer.html($sliderItems);
        createProductSlider();
    };

    useLayoutEffect(() => {
        let $slider = $(sliderSectionID).find('.slick-initialized');
        if ($slider.length) {
            $slider.slick('unslick');
        }

        if (list.length > 0) {
            $sliderContainer.show();
        } else {
            $sliderContainer.hide();
        }

        duplicateSlideItem();
    }, [JSON.stringify(list)]);

    return (
        <React.Fragment>
            <div className='tmp-product-slider hidden'>
                {list.map((item, key) => {
                    return (
                        <ProductSliderItem
                            key={key}
                            item={item}
                            currencyFormat={currencyFormat}
                            currencyDisplayCode={currencyDisplayCode}
                            locale={locale}
                        />
                    );
                })}
            </div>
            <div className='products-slider product-grid slider'>
                <div className='slider__box'>
                    <div className='slider__nav' />
                    <div className='slider__cycle' />
                </div>
            </div>
        </React.Fragment>
    );
}

// default props
RelatedProductList.defaultProps = {
    hasInitialized: false,
    list: [],
};
// validate props
RelatedProductList.propTypes = {
    hasInitialized: PropTypes.bool,
    list: PropTypes.array,
};

export default RelatedProductList;
